import React, {useEffect,useState} from "react";
import Sidebar from "../../../Components/Sidebar";
import AddMembersForm from "../../../Components/AddMembersForm";
//import MembersTable from "../../../Components/MembersTable";
import ManagementMembersTable from "../../../Components/ManagementMembersTable";
import { addBoardMember,fetchBoardMembers,deleteBoardMemberById, updateBoardMember } from "../../../redux/actions/aboutUsActions";
import { useDispatch, useSelector } from "react-redux";
import PageComponent from "../../../Components/PageComponent";

function Management() {

  const dispatch = useDispatch();
  const [deletePopup, setDeletePopup] = useState({ isOpen: false, data: null });

  const { data: boardMemberData = [], loading } = useSelector(
    (state) => state.aboutUs.boardMember
  );

  useEffect(() => {
    dispatch(fetchBoardMembers());
  }, [dispatch]);

  const handleDeleteConfirm = async () => {
    if (deletePopup.data) {
      await dispatch(deleteBoardMemberById(deletePopup.data.id));
      setDeletePopup({ isOpen: false, data: null });
      dispatch(fetchBoardMembers());
    }
  };

  const closeDeletePopup = () => {
    setDeletePopup({ isOpen: false, data: null });
  };

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      {/* Sidebar */}
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      {/* Content Section */}
      <div className="flex-1 p-6 ml-64">
        {/* Breadcrumb */}
        <div className="flex items-center mb-6 space-x-2 text-3xl text-gray-500">
          <span>About Us</span>
          <span>/</span>
          <span className="text-black">Board of Management</span>
        </div>

        {/* Forms */}
    
        <AddMembersForm title="Add Board of Management Member " addMemberAction={addBoardMember} fetchMembersAction={fetchBoardMembers} />
        <ManagementMembersTable 
        title="Already added Board of Management Member "
        editTitle = "Edit Board of Management Member" 
        MemberData={boardMemberData}
        handleDeleteConfirm={handleDeleteConfirm}
        deletePopup={deletePopup}
        setDeletePopup={setDeletePopup}
        closeDeletePopup={closeDeletePopup}
        loading={loading}
        fetchMembers={fetchBoardMembers}
        updateMember={updateBoardMember} />
        {/* <DisplayMessage /> */}
      </div>
    </div>
    </PageComponent></>
  );
}

export default Management;
